/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnalyticsAdminReportUpdate } from '../models/AnalyticsAdminReportUpdate';
import type { AnalyticsReport } from '../models/AnalyticsReport';
import type { Company } from '../models/Company';
import type { CompanyEdit } from '../models/CompanyEdit';
import type { CompanyGroups } from '../models/CompanyGroups';
import type { DataLoader } from '../models/DataLoader';
import type { Survey } from '../models/Survey';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminCompanyService {

    /**
     * get Company Information
     * @returns Company Success
     * @throws ApiError
     */
    public static listCompanies({
        isAllowCsAccess,
        search,
        limit,
        offset,
        ignorePagination,
        includeQuickSight,
        groupId,
    }: {
        /**
         * isAllowCSAccess flag
         */
        isAllowCsAccess?: boolean,
        search?: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        ignorePagination?: boolean,
        includeQuickSight?: boolean,
        /**
         * Filter companies by group ID
         */
        groupId?: string,
    }): CancelablePromise<Array<Company>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company',
            query: {
                'isAllowCSAccess': isAllowCsAccess,
                'search': search,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'includeQuickSight': includeQuickSight,
                'groupId': groupId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Company Information
     * @returns any Success
     * @throws ApiError
     */
    public static createCompany({
        requestBody,
    }: {
        requestBody?: Company,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Quick Sight Company Information
     * @returns any Success
     * @throws ApiError
     */
    public static createQuickSightCompany({
        requestBody,
    }: {
        requestBody?: {
            companyId: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/company/quickSight',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get distinct company group IDs
     * @returns CompanyGroups Success
     * @throws ApiError
     */
    public static getCompanyGroups(): CancelablePromise<CompanyGroups> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/groups',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * get Company Information
     * @returns Company Success
     * @throws ApiError
     */
    public static getCompanyInformation({
        id,
    }: {
        /**
         * Company ID
         */
        id: number,
    }): CancelablePromise<Company> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * edit Company Information
     * @returns any Success
     * @throws ApiError
     */
    public static editCompany({
        id,
        requestBody,
    }: {
        /**
         * Company ID
         */
        id: number,
        requestBody: CompanyEdit,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/company/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * de-provision company
     * @returns any Success
     * @throws ApiError
     */
    public static deProvisionCompany({
        id,
    }: {
        /**
         * Company ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/company/{id}/deprovisioning',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Files of Company
     * @returns any Success
     * @throws ApiError
     */
    public static listCompanyFiles({
        id,
        type,
        search,
        limit,
        offset,
        sort,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * Type of file
         */
        type?: string,
        /**
         * Search by file name
         */
        search?: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
    }): CancelablePromise<{
        count?: number;
        rows?: Array<DataLoader>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/files',
            path: {
                'id': id,
            },
            query: {
                'type': type,
                'search': search,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Files of Company
     * @returns any Success
     * @throws ApiError
     */
    public static listCompanySftpFiles({
        id,
        search,
        sort,
        limit,
        offset,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * Search by file name
         */
        search?: string,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        count?: number;
        rows?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/files/sftp',
            path: {
                'id': id,
            },
            query: {
                'search': search,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Files of Company
     * @returns any Success
     * @throws ApiError
     */
    public static listCompanyWorkdayRaaSFiles({
        id,
        search,
        sort,
        limit,
        offset,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * Search by file name
         */
        search?: string,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        count?: number;
        rows?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/files/workday',
            path: {
                'id': id,
            },
            query: {
                'search': search,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * download file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadCompanyFile({
        id,
        fileId,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * File ID
         */
        fileId: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/file/{fileId}',
            path: {
                'id': id,
                'fileId': fileId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * download file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadCompanySftpFile({
        id,
        key,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * File key
         */
        key: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/file/sftp',
            path: {
                'id': id,
            },
            query: {
                'key': key,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * download file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadCompanyWorkdayRaaSFile({
        id,
        key,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * File key
         */
        key: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/file/workday',
            path: {
                'id': id,
            },
            query: {
                'key': key,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Surveys of Company
     * @returns Survey Success
     * @throws ApiError
     */
    public static listCompanySurveys({
        id,
        surveyVendorId,
        surveyJobProfileId,
        isPublic,
        search,
        limit,
        offset,
        sort,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * Survey Vendor ID
         */
        surveyVendorId?: string | null,
        /**
         * Survey Job Profile ID
         */
        surveyJobProfileId?: string | null,
        /**
         * isPublic
         */
        isPublic?: boolean | null,
        /**
         * search
         */
        search?: string | null,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Sort object
         */
        sort?: {
            name?: string;
            version?: string;
            effectiveDate?: string;
            public?: string;
            createdAt?: string;
            updatedAt?: string;
        },
    }): CancelablePromise<Array<Survey>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/surveys',
            path: {
                'id': id,
            },
            query: {
                'surveyVendorId': surveyVendorId,
                'surveyJobProfileId': surveyJobProfileId,
                'isPublic': isPublic,
                'search': search,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Surveys of Company
     * @returns any Success
     * @throws ApiError
     */
    public static updateCompanySurveys({
        id,
        requestBody,
    }: {
        /**
         * Company ID
         */
        id: number,
        requestBody: {
            surveyIdsToAdd?: Array<string>;
            surveyIdsToDelete?: Array<string>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/company/{id}/surveys',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Company Dashboards
     * @returns any Success
     * @throws ApiError
     */
    public static listCompanyDashboards({
        id,
        reportType,
        search,
        limit,
        offset,
        sort,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * Type of report
         */
        reportType?: string,
        /**
         * Search by report name
         */
        search?: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
    }): CancelablePromise<{
        metadata: {
            totalData: number;
        };
        results: Array<AnalyticsReport>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/company/{id}/dashboards',
            path: {
                'id': id,
            },
            query: {
                'reportType': reportType,
                'search': search,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                423: `The specified resource is unavailable`,
            },
        });
    }

    /**
     * Toggle Dashboard availability
     * @returns any Success
     * @throws ApiError
     */
    public static updateDashBoard({
        id,
        reportId,
        requestBody,
    }: {
        /**
         * Company ID
         */
        id: number,
        /**
         * Report ID
         */
        reportId: string,
        requestBody: AnalyticsAdminReportUpdate,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/company/{id}/dashboards/{reportId}',
            path: {
                'id': id,
                'reportId': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
